export default __webpack_public_path__ + "static/media/word_doc.a02115e2.svg";